<template>
  <!-- downloadPackage Modal -->
  <div
    class="modal fade"
    id="downloadPackageModal"
    tabindex="-1"
    aria-labelledby="downloadPackageModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="downloadPackageModalLabel">
            Download Confirmation
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div v-show="selectedSecurityGrading != 'Secret'" class="modal-body">
          You have selected a non-secret {{ selectedContent }}. Do you want to
          proceed to download?
        </div>
        <div v-show="selectedSecurityGrading == 'Secret'" class="modal-body">
          You have selected a
          <span style="color: red"
            >{{ selectedSecurityGrading }} {{ selectedContent }}</span
          >. Do you want to proceed to download?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="downloadPackage"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDownloadStore } from "@/stores/download";
import { ref, watch } from "vue";

const downloadStore = useDownloadStore();
const props = defineProps({
  selectedId: { type: String },
  selectedContent: { type: String },
  selectedSecurityGrading: { type: String },
});
const selectedPackages: any = ref(props.selectedId);
const selectedContent: any = ref(props.selectedContent);
const selectedSecurityGrading: any = ref(props.selectedSecurityGrading);

watch(
  () => props.selectedId,
  (newId) => (selectedPackages.value = newId)
);

watch(
  () => props.selectedContent,
  (newContent) => (selectedContent.value = newContent)
);

watch(
  () => props.selectedSecurityGrading,
  (newSecurityGrading) => (selectedSecurityGrading.value = newSecurityGrading)
);

const downloadPackage = async () => {
  await downloadStore.retrieveDownloads(selectedPackages.value,"not-admin");
};
</script>
